<template src="../templates/normal_fcont_31.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryTop from '../components/FuncSearchGalleryTop'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import UseDesignPaperList from '../components/UseDesignPaperList'
import InstaGalleryButton from '../components/InstaGalleryButton'
import InfoMachineTranslation from '../components/InfoMachineTranslation'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryTop,FuncSearchGalleryQR,
   PrintButton,UseDesignPaperList,InstaGalleryButton,InfoMachineTranslation
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['31-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['31-2']}
    ]};
  }
};
</script>
<style />


